import { Linkedin, Mail, Facebook, Instagram } from "lucide-react";
import { scrollToId } from "@/components/Navbar";

const TikTokIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16" {...props}>
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
  </svg>
);

export default function Footer() {
  return (
    <footer className="bg-[#071627] border-t border-white/5" data-testid="footer">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-10 flex flex-col md:flex-row items-center justify-between gap-8">
        <button onClick={() => scrollToId("home")} data-testid="footer-brand-logo">
          <img
            src="/verixx-logo.png"
            alt="VERIXX H2O — A LeakLock Company"
            className="h-10 w-auto drop-shadow-[0_0_12px_rgba(28,156,232,0.3)]"
          />
        </button>

        <div className="text-center" data-testid="footer-company">
          <p className="font-display font-bold text-sm text-white uppercase tracking-wide">LeakLock Ltd</p>
          <p className="text-xs text-slate-400 mt-1">Verix H₂O — A LeakLock Company</p>
          <a
            href="mailto:luke@leaklock.uk.com"
            className="block text-xs text-slate-400 hover:text-[#2aa7ec] mt-1.5 transition-colors duration-300"
            data-testid="footer-email-text"
          >
            luke@leaklock.uk.com
          </a>
        </div>

        <div className="flex items-center gap-3" data-testid="footer-social-links">
          {[
            { href: "https://www.linkedin.com/in/luke-smith-615443389", label: "LinkedIn", id: "linkedin", Icon: Linkedin },
            { href: "https://www.facebook.com/share/1CJpa4APeP/", label: "Facebook", id: "facebook", Icon: Facebook },
            { href: "https://www.instagram.com/verixh2o", label: "Instagram", id: "instagram", Icon: Instagram },
            { href: "https://www.tiktok.com/@verixh2o", label: "TikTok", id: "tiktok", Icon: TikTokIcon },
          ].map(({ href, label, id, Icon }) => (
            <a
              key={id}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={label}
              className="w-9 h-9 rounded-full border border-white/15 flex items-center justify-center text-slate-300 hover:text-white hover:border-[#2aa7ec] hover:bg-[#1c9ce8]/15 transition-[color,border-color,background-color] duration-300"
              data-testid={`footer-${id}-link`}
            >
              <Icon className="w-4 h-4" />
            </a>
          ))}
          <a
            href="mailto:luke@leaklock.uk.com"
            aria-label="Email"
            className="w-9 h-9 rounded-full border border-white/15 flex items-center justify-center text-slate-300 hover:text-white hover:border-[#2aa7ec] hover:bg-[#1c9ce8]/15 transition-[color,border-color,background-color] duration-300"
            data-testid="footer-email-link"
          >
            <Mail className="w-4 h-4" />
          </a>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="mx-auto max-w-7xl px-5 sm:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-[11px] text-slate-500">
          <span data-testid="footer-copyright">© 2026 LeakLock. All rights reserved.</span>
          <span data-testid="footer-tagline">Built for a stronger tomorrow.</span>
        </div>
      </div>
    </footer>
  );
}
